import type { Money } from "./types";

export function money(amountMinor = 0, currency = "GBP"): Money {
  return { amountMinor, currency };
}

export function parseMoneyInput(value: string, currency = "GBP"): Money {
  const normalized = value.replace(/[^\d.-]/g, "");
  const parsed = Number.parseFloat(normalized);
  if (Number.isNaN(parsed)) {
    return money(0, currency);
  }
  return money(Math.round(parsed * 100), currency);
}

export function moneyInputValue(value: Money | undefined): string {
  if (!value) {
    return "";
  }
  return (value.amountMinor / 100).toFixed(2);
}

export function formatMoney(value: Money): string {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: value.currency,
    maximumFractionDigits: 2
  }).format(value.amountMinor / 100);
}

export function formatPercent(value: number): string {
  return new Intl.NumberFormat("en-GB", {
    style: "percent",
    maximumFractionDigits: 0
  }).format(value);
}

export function addMoney(...values: Money[]): Money {
  const currency = values[0]?.currency ?? "GBP";
  return money(
    values.reduce((total, value) => total + value.amountMinor, 0),
    currency
  );
}

export function negateMoney(value: Money): Money {
  return money(-value.amountMinor, value.currency);
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}
